// extracted by mini-css-extract-plugin
export default {"menu":"account-menu_menu__hykoQ"};